import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const setIsMobile = useState(window.innerWidth < 768)[1];

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setIsMobile]);

  return (
    <div className="app-container">
      {/* Sidebar */}
      <div className={`sidebar${sidebarOpen ? ' sidebar-mobile' : ''}${sidebarCollapsed ? ' sidebar-collapsed' : ''}`}>
        <Sidebar 
          isMobile={sidebarOpen} 
          isCollapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar} 
          toggleCollapse={toggleSidebarCollapse}
        />
      </div>

      {/* Main content */}
      <div className="main-content">
        <div className="content-wrapper">
          <Header toggleSidebar={toggleSidebar} />
          <main className="page-content">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
